@if (!loading && smartphoto) {
  <div class="smartphoto-info">
    <div class="smartphoto-info__header">
      @if (hasDeadline$ | async) {
        <div class="smartphoto-info__header-date">
          <span class="smartphoto-info__date-label">{{ 'deadline' | i18nextEager }}</span>
          @if (!smartphoto.deadlineSelfadjust) {
            <span class="smartphoto-info__date-value" data-test-id="smartphoto-deadline">{{ 'invalid_date' | i18nextEager }}</span>
          } @else {
            <span class="smartphoto-info__date-value" data-test-id="smartphoto-deadline">{{ smartphoto.deadlineSelfadjust }}</span>
          }
        </div>
      } @else {
        <div class="smartphoto-info__header-date">
          <span class="smartphoto-info__date-label">{{ 'created_at' | i18nextEager }}</span>
          <span class="smartphoto-info__date-value" data-test-id="smartphoto-createdAt">
            {{ smartphoto.createdAt ? (smartphoto.createdAt * 1000 | date: 'dd/MM/yy') : '-' }}
          </span>
        </div>
      }

      @if (statusDetails$ | async; as statusDetail) {
        <div class="smartphoto-info__header-status-tag">
          <bdeo-tag
            data-test-id="smartphoto-status"
            size="medium"
            text="{{ 'statuses.' + statusDetail.lang | i18nextEager }}"
            color="{{ statusDetail.color }}"
            icon="{{ statusDetail.icon }}"
          ></bdeo-tag>
        </div>
      }
    </div>

    @if (cardFields.length) {
      <div data-test-id="card-fields-container">
        @for (field of cardFields; track $index) {
          <div class="smartphoto-info__fields-row">
            <div class="smartphoto-info__fields-label">
              <span>{{ field.fieldDescription }}</span>
            </div>
            <div class="smartphoto-info__fields-value">
              <span [attr.data-test-id]="'smartphoto-' + field.fieldName">{{ field.value }}</span>
            </div>
          </div>
        }
      </div>
    } @else {
      @if (smartphoto.caseRef) {
        <div class="smartphoto-info__fields-row">
          <div class="smartphoto-info__fields-label">
            <span>{{ 'claim_number' | i18nextEager }}</span>
          </div>
          <div class="smartphoto-info__fields-value">
            <span data-test-id="smartphoto-caseRef">{{ smartphoto.caseRef }}</span>
          </div>
        </div>
      }

      @if (smartphoto.vehicleType) {
        <div class="smartphoto-info__fields-row">
          <div class="smartphoto-info__fields-label">
            <span>{{ 'vehicle_type' | i18nextEager }}</span>
          </div>
          <div class="smartphoto-info__fields-value">
            <span data-test-id="smartphoto-vehicleType">{{ 'vehicle_types.' + smartphoto.vehicleType | i18nextEager }}</span>
          </div>
        </div>
      }

      @if (smartphoto.plate) {
        <div class="smartphoto-info__fields-row">
          <div class="smartphoto-info__fields-label">
            <span>{{ 'plate' | i18nextEager }}</span>
          </div>
          <div class="smartphoto-info__fields-value">
            <span data-test-id="smartphoto-plate">{{ smartphoto.plate }}</span>
          </div>
        </div>
      }
    }

    @if (canShowBasket) {
      <bdeo-divider class="smartphoto-info__divider" type="horizontal"></bdeo-divider>
      <div class="smartphoto-info__fields-row">
        <div class="smartphoto-info__fields-label">
          <span>{{ 'baskets.result' | i18nextEager }}</span>
        </div>
        <div class="smartphoto-info__fields-value">
          <span data-test-id="basketing-result">{{
            !(company$ | async)?.smartphoto?.baskets && i18next.exists('brokers:baskets.title_' + smartphoto.basket?.name)
              ? ('baskets.title_' + smartphoto.basket?.name | i18nextEager)
              : (smartphoto.basket?.name ?? '-')
          }}</span>
          @if (canShowEditBasket) {
            <bdeo-button
              data-test-id="edit-basket-button"
              size="medium"
              type="secondary"
              icon="action-pen-outline"
              skin="outline"
              bigIcon
              (click)="drawer.open()"
            ></bdeo-button>
          }
        </div>
      </div>
    }
    <bdeo-divider class="smartphoto-info__divider" type="horizontal"></bdeo-divider>

    @if (smartphoto.createdAt) {
      <div class="smartphoto-info__fields-row">
        <div class="smartphoto-info__fields-label">
          <span>{{ 'created_at' | i18nextEager }}</span>
        </div>
        <div class="smartphoto-info__fields-value">
          <span data-test-id="smartphoto-createdAt-small">{{ (smartphoto.createdAt || 0) * 1000 | date: 'dd/MM/yy' }}</span>
        </div>
      </div>
    }

    @if ((hasDeadline$ | async) && smartphoto.deadlineSelfadjust) {
      <div class="smartphoto-info__fields-row">
        <div class="smartphoto-info__fields-label">
          <span>{{ 'deadline' | i18nextEager }}</span>
        </div>
        <div class="smartphoto-info__fields-value">
          <span data-test-id="smartphoto-deadline-small">{{ smartphoto.deadlineSelfadjust }}</span>
        </div>
      </div>
    }

    @if (smartphoto.dates.finished) {
      <div class="smartphoto-info__fields-row">
        <div class="smartphoto-info__fields-label">
          <span>{{ 'finished_at' | i18nextEager }}</span>
        </div>
        <div class="smartphoto-info__fields-value">
          <span data-test-id="smartphoto-finishedAt">{{ smartphoto.dates.finished.getTime() || 0 | date: 'dd/MM/yy' }}</span>
        </div>
      </div>
    }

    @if (infoFields.length) {
      @for (field of infoFields; track $index) {
        <div class="smartphoto-info__fields-row">
          <div class="smartphoto-info__fields-label">
            <span>{{ field.fieldDescription }}</span>
          </div>
          <div class="smartphoto-info__fields-value">
            @if (field.dataType === 'dateEpoch') {
              <span>{{ (field.value ?? 0) * 1000 | date: 'dd/MM/yy' }}</span>
            } @else {
              <span>{{ field.value }}</span>
            }
          </div>
        </div>
      }
    }
  </div>
} @else {
  <app-info-skeleton></app-info-skeleton>
}

<app-smartphoto-basket-edit-drawer
  [smartphoto]="smartphoto"
  [company]="(company$ | async) ?? undefined"
></app-smartphoto-basket-edit-drawer>
